import axios from 'axios'
import app from '../main.js'
import store from '../store/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_SHARED_API,
  // timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
})

api.interceptors.request.use(
  async config => {
    const bearerToken = app.config.globalProperties.$cookies.get('bearerToken')
    config.headers.Authorization = 'Bearer ' + bearerToken
    return config
  }
)

api.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  let currentUrl = window.location.pathname;
  if (error?.response?.status === 401) {
    if (currentUrl !== '/login') {
      return store.dispatch("enableLoginModal")
    }
  } else {
    return Promise.reject(error);
  }
});

export default api
